import * as React from 'react'
import ReactModal from 'react-modal'
import styled, { css } from 'styled-components'

import media from '../../../services/generateMediaQueries'
import { loungeFormat } from '../../../services/data/dateFormat'
import ActionButton from '../../ui/ActionButton/ActionButton'
import Icon from '../../ui/Icon/Icon'

import ZingBrand from '../../../assets/img/brand.webp'
import LoungePassBackground from '../../../assets/img/lounge-pass/lounge-pass-background.png'
import LoungeImage from '../../../assets/img/lounge-pass/lounge-image.png'
// import GCashWord from '../../../assets/img/gcash/gcash-word.png'

const StyledReactModal = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    top: 0;
    right: 0;
    height: 100% !important;
    border-radius: 0;
    max-width: unset;
    max-height: unset;
  `}
`

const ModalContent = styled.div`
  position: relative;
  margin: 3rem auto;
  width: 365px;
  min-height: 400px;
  border-radius: 8px;
  overflow: hidden;

  ${media.lessThan('small')`
    margin: 0;
    height: 100%;
    width: 100%;
    border-radius: 0;
  `}
`

const Header = styled.div`
  padding-top: 3rem;
  margin-bottom: 30px;
  background-image: url('${LoungePassBackground}');
  background-size: cover;
  background-position: center -45px;
  background-repeat: no-repeat;
`

const HeaderIcon = styled.img.attrs({ src: ZingBrand })`
  display: block;
  width: 115px;
  margin: 0 auto;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
`

const Title = styled.h2`
  font-family: var(--font-family-ayala-display-sans);
  font-size: 1.2rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.5625rem;
  text-align: center;
  margin: 0 2rem;
  margin-bottom: 1rem;
  color: #fff;
  // position: absolute;
  // left: -999999px;
`

const ContentDescription = styled.div`
  padding: 0 2.5rem;
  padding-bottom: 1.5rem;
`

const Description = styled.p`
  font-size: 0.875rem;
  letter-spacing: 0.1px;
  line-height: 1.3125rem;
  margin: 1.25rem 0;
  padding-top: 1.25rem;
  text-align: left;
`

const DefaultCloseButton = styled.button`
  position: absolute;
  color: #ffffff;
  border: 0;
  top: 15px;
  right: 15px;
  font-size: 25px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 100%;
  outline: none;

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`
// ST-7886 - Lounge Pass
// const Counter = styled.strong`
//   color: var(--color-primary);
//   font-size: 1.25rem;
//   text-align: center;
//   display: block;
// `

const StyledLoungeImage = styled.img`
  display: block;
  margin: 0 auto;
  position: relative;
  bottom: -15px;
  width: 11.5rem;
`

const ModalContentWrapper = styled.div`
  overflow: auto;
  max-height: 100vh;
  width: 100%;
`

const Content = styled.div`
  background: #ffffff;
  border-radius: 8px;
`

const DateTime = styled.h2`
  color: white;
  font-size: 1.2rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.5625rem;
  text-align: center;
  opacity: 0.5;
  margin: 0;
  position: relative;
  z-index: 1;
`

const GCashWordContainer = styled.img`
  height: 17px;
  vertical-align: top;
`

const StyledGCashButton = styled(ActionButton)`
  margin-top: 1rem;
  width: -webkit-fill-available;
  border-radius: 4px;
  border: 1px solid #007dfe;
  color: #ffffff !important;
  background-color: #007dfe;
  text-transform: uppercase;

  &:hover {
    color: #fff;
    background-color: #007dfe;
  }
`

const overlay = {
  zIndex: 10000,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

function LoungePassExhaustedModal(props) {
  const {
    show,
    onClose,
    onAdd,
    shouldCloseOnOverlayClick = true,
    zIndex,
    onGCashLink,
    isGCashValidating,
    ...restProps
  } = props

  const [dateNow, setDateNow] = React.useState(new Date())

  const tick = () => {
    setDateNow(new Date())
  }

  React.useEffect(() => {
    const timerID = setInterval(() => tick(), 1000)

    return () => {
      clearInterval(timerID)
    }
  })

  // return (
  //   <StyledReactModal
  //     isOpen={show}
  //     style={{
  //       overlay: {
  //         ...overlay,
  //         zIndex,
  //       },
  //     }}
  //     closeTimeoutMS={150}
  //     bodyOpenClassName="sticky-modal-open"
  //     htmlOpenClassName="sticky-modal-open"
  //     shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
  //     onRequestClose={onClose}
  //   >
  //     <ModalContent>
  //       <DefaultCloseButton zIndex={zIndex} onClick={onClose}>
  //         <Icon name="x" />
  //       </DefaultCloseButton>
  //       <Header>
  //         <HeaderIcon />
  //         <Title>Enjoy unlimited access to Ayala Malls Customer Lounges.</Title>
  //         {/* <DateTime>{loungeFormat(dateNow)}</DateTime> */}
  //         <StyledLoungeImage src={LoungeImage} />
  //       </Header>
  //       <Title>Customer Lounge Pass</Title>

  //       <Counter>You have 0 customer lounge passes left.</Counter>
  //       <Description>
  //         This pass is valid for you at Ayala Malls Customer Lounges nationwide.
  // //       </Description>
  //       <BlockActionButton onClick={onAdd} variant="primary">
  //         Link Card Now
  //       </BlockActionButton>
  //       <BlockActionButton onClick={onClose}>
  //         I will add my card later
  //       </BlockActionButton>
  //     </ModalContent>
  //   </StyledReactModal>
  // )
  return (
    <StyledReactModal
      isOpen={show}
      style={{
        overlay: {
          ...overlay,
          ...(zIndex ? { zIndex } : {}),
        },
        content,
      }}
      onRequestClose={onClose}
      closeTimeoutMS={150}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
      {...restProps}
    >
      <ModalContentWrapper>
        <ModalContent>
          <DefaultCloseButton zIndex={zIndex} onClick={onClose}>
            <Icon name="x" />
          </DefaultCloseButton>
          <Content>
            <Header>
              <HeaderIcon />
              <Title>Enjoy access to Ayala Malls Customer Lounges.</Title>
              <DateTime>{loungeFormat(dateNow)}</DateTime>
              <StyledLoungeImage src={LoungeImage} />
            </Header>
            <ContentDescription>
              {/* ST-7886 - Lounge Pass
            <Counter>You have 0 customer lounge passes left.</Counter> */}
              <Description>
                Your Zing membership entitles you access
                <br />
                to Customer Lounges at Ayala Malls. Flash your Lounge Pass at
                the Customer Lounge entrance, and you’re good to go.
              </Description>

              {/* <BlockActionButton onClick={onAdd} variant="primary">
                Link Card Now
              </BlockActionButton> */}

              {/*
               ST-7886 - Lounge Pass
               <StyledGCashButton
                onClick={isGCashValidating ? onClose : onGCashLink}
              >
                Link <GCashWordContainer src={GCashWord} alt={'gcash logo'} />{' '}
                Now
              </StyledGCashButton> */}
            </ContentDescription>
          </Content>
        </ModalContent>
      </ModalContentWrapper>
    </StyledReactModal>
  )
}

LoungePassExhaustedModal.defaultProps = {
  // TODO: specify default props
}

LoungePassExhaustedModal.propTypes = {
  // TODO: specify prop types
}

export default LoungePassExhaustedModal
